import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Label above, control, helper or error below (DESIGN.md §6). */
export function Field({
  id,
  label,
  error,
  helperText,
  descriptionId,
  className,
  children,
}: {
  id: string;
  label?: ReactNode;
  error?: string;
  helperText?: string;
  descriptionId?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('w-full', className)}>
      {label ? (
        <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-ink">
          {label}
        </label>
      ) : null}
      {children}
      {error ? (
        <p id={descriptionId} className="mt-1.5 text-[13px] text-critical">
          {error}
        </p>
      ) : helperText ? (
        <p id={descriptionId} className="mt-1.5 text-[13px] text-ink-2">
          {helperText}
        </p>
      ) : null}
    </div>
  );
}

export const controlClasses = cn(
  'flex w-full rounded-control border border-line bg-surface text-sm text-ink',
  'placeholder:text-ink-3',
  'transition-[border-color,box-shadow] duration-150',
  'hover:border-line-strong',
  'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-1 focus-visible:ring-accent',
  'aria-invalid:border-critical aria-invalid:focus-visible:ring-critical',
  'disabled:cursor-not-allowed disabled:opacity-50'
);
